import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../utils/storeApp";
import { Column } from "primereact/column";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

const ListDirectory = () => {
  const { SetSharedObject, userToken, sharedObject, userRole } = useUserStore(
    (state) => ({
      SetSharedObject: state.SetSharedObject,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
    }),
  );
const isAdmin =
    userRole === "SES ADMINISTRATOR" ||
    userRole === "ADMINISTRATOR" ||
    userRole === "SYSTEMADMINISTRATOR";

  const [userObj, setUserObj] = useState([]);
  const [showGridFlag, SetShowGridFlag] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState(false);
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [selectedGridProducts, setSelectedGridProducts] = useState([]);

  useEffect(() => {
    if (sharedObject.AdvSearchObj) {
      setSelectedProducts(sharedObject.DirectoryType);
      if (sharedObject.AdvSearchObj.length > 0) {
        SearchList(
          sharedObject.AdvSearchObj,
          sharedObject.AdvSearchObj[0].DirectoryType,
        );
        SetShowGridFlag(true);
      } else {
        setUserObj([]);
        SetShowGridFlag(false);
        setSelectedProducts(false);
      }
    }
  }, [sharedObject.AdvSearchObj]);

  const SearchList = (obj, type) => {
    setSelectedGridProducts([]);
    let tempObj = [];
    for (const row of obj) {
      row.DirectoryType = type;
      let cs = (
        <button
          type="button"
          className="btn btn-link border-0 align-baseline font-weight-bold"
          aria-label={`View details for ${row.name || "this entry"}`}
          onClick={(el) => {
            searchName(row, "show");
            el.preventDefault();
          }}
        >
          {row.name}
        </button>
      );
      row.GridLinkCourse = cs;
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };

  const searchName = async (row) => {
    setSelectedGridProducts([row]);
    setProcessing(true);
    let call =
      "/directorySearch/GetDetailById?searchById=" +
      row.id +
      "&searchType=" +
      row.DirectoryType;
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      var dt = res.data.data;
      await SetSharedObject("userDirectSearch", dt);
      $("#detailsDirectoryModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const SendMessage = async () => {
    setProcessing(true);
    let call = "/directorySearch/DirectorySendEmail";
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      let str = "";
      if (dt) {
        selectedGridProducts.map((el) => {
          str += `${el.directEmail};`;
          return `${el.directEmail};`;
        });
        if (typeof window !== "undefined") {
          window.open("/webmail/Home/Index?MailtoAddress=" + str, "_self");
        }
      } else {
        $("#DirAlertModal").modal("show");
      }
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const AddContacts = async (val) => {
    setProcessing(true);
    const addObj = selectedGridProducts.map((el) => {
      const obj = {
        UserName: el.name,
        Email: el.directEmail,
        Address: el.address,
        City: el.city,
        State: el.state,
        Zip: el.zip,
      };
      return obj;
    });
    let call = "/directorySearch/addEmailToContact";
    const res = await CallAPI(call, addObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      $("#DirConfirmModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const defaultSearch = async (type) => {
    let obj = {
      UserId: null,
      OrganizationId: null,
      OrganizationKind: "",
      DirectorySource: "All",
      DirectoryType: type,
      SearchByName: null,
      FirstName: null,
      LastName: null,
      OrganizationName: null,
      NationalProviderID: null,
      ContactEmail: null,
      DirectEmail: null,
      Address: null,
      City: null,
      Zip: null,
      SpecialitySpecialization: null,
      DomainName: null,
      Resultsize: 0,
    };

    setProcessing(true);
    let call = "/directorySearch/Search";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      var dt = res.data.data.pageItems;
      SearchList(dt, type);
      SetShowGridFlag(true);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const setType = async (val) => {
    if (val === "") return;
    await SetSharedObject("DirectoryType", val);
    setSelectedProducts(val);
    defaultSearch(val);
  };
  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const ServDesc = (dt) => {
    let val = dt.serV_DESC;
    const obj = sharedObject?.getServDesc;
    let servDesc = "";
    if (!isEmpty(obj))
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].code === val) {
          return obj[i].display;
        }
      }
    return servDesc;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  return (
    <main className="ListDirectory">
      {errDetailFlag ? (
        <div
          className={`alert alert-danger`}
          dangerouslySetInnerHTML={{ __html: errDetailMsg }}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        />
      ) : null}
      <header className={isAdmin ? undefined : "HeaderDirectory ht-5 sp-t1"} role="banner">
        <h4 className="admin-title mid-main-bar sp-pad7">
          Directory Search{" "}
          {selectedProducts === "Providers" ? (
            <>for Providers</>
          ) : selectedProducts === "Organizations" ? (
            <>for Organizations</>
          ) : null}
        </h4>

        <div className="spacer-inline v-top w-md12">
          <label htmlFor="directoryTypeSelect" className="sr-only">
            Directory Type
          </label>
          <select
            id="directoryTypeSelect"
            className="form-control w-md8 spacer-inline spacer-margin6 shade-2"
            onChange={(e) => {
              setType(e.target.value);
            }}
            value={selectedProducts}
          >
            <option value="">DIRECTORY TYPE</option>
            <option value="Providers">Provider</option>
            <option value="Organizations">Organization</option>
          </select>

          <button
            type="button"
            className="btn btn-primary shade-1 "
            data-target="#advDirSearchModal"
            data-toggle="modal"
            aria-haspopup="dialog"
            aria-label="Open advanced directory search"
          >
            Search
          </button>
        </div>
      </header>

      {showGridFlag ? (
        <section className="grid-layout" aria-label="Directory search results">
          <DataTable
            value={userObj}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            tableStyle={{ minWidth: "50rem" }}
            dataKey="id"
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            columnResizeMode="expand"
            resizableColumns
            selectionMode={"checkbox"}
            selection={selectedGridProducts}
            onSelectionChange={(e) => {
              setSelectedGridProducts(e.value);
            }}
            selectionAutoFocus={false}
          >
            {sharedObject.getUserEmails &&
            sharedObject.getUserEmails.length > 0 ? (
              <Column selectionMode="multiple" className="w-s"></Column>
            ) : null}
            <Column field="GridLinkCourse" header="Name" sortable></Column>
            {/*<Column*/}
            {/*  field="DirNpi"*/}
            {/*  header="NPI"*/}
            {/*  className="w-md1"*/}
            {/*  sortable*/}
            {/*></Column>*/}
            <Column
              field="directEmail"
              header="Direct Email"
              className="truncate"
              sortable
            ></Column>
            <Column
              field="emailPurpose"
              header="Email Purpose"
              sortable
            ></Column>
            <Column
              field="address"
              header="Address"
              className="truncate"
              sortable
            ></Column>
            <Column field="city" header="City" sortable></Column>
            <Column
              field="state"
              header="State"
              className="w-md4"
              sortable
            ></Column>
            <Column field="zip" header="Zip" className="w-sm" sortable></Column>
            <Column
              field="serV_DESC"
              header="Service Description"
              body={ServDesc}
              sortable
            ></Column>

            {/*{sharedObject?.AdvSearchAnswers?.DirectoryType !== "Providers" ? (*/}
            {/*  <Column field="orgKind" header="Organization Type" sortable ></Column>*/}
            {/*) : null}*/}
          </DataTable>
          {sharedObject.getUserEmails &&
          sharedObject.getUserEmails.length > 0 ? (
            <div className="paging">
              <div className="spacer-inline spacer-margin9">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(el) => AddContacts()}
                  disabled={selectedGridProducts.length === 0}
                  aria-describedby="selectionHint"
                >
                  Add to Contacts
                </button>

                <button
                  className="btn btn-primary spacer-margin2"
                  disabled={selectedGridProducts.length === 0}
                  onClick={(el) => SendMessage()}
                  aria-describedby="selectionHint"
                >
                  Send Message
                </button>
                <span id="selectionHint" className="sr-only">
                  Select one or more rows in the table above before using these
                  actions.
                </span>
              </div>
            </div>
          ) : null}
        </section>
      ) : (
        <section
          className="empty-grid"
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          There are currently no results.
        </section>
      )}

      {processing && (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="directory-list-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="directory-list-loader">
            {loadingText}
          </div>
        </div>
      )}
    </main>
  );
};

export default ListDirectory;
